export default __webpack_public_path__ + "static/media/filter.918c8c3f.svg";